import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const initialState = null as null | string;

const slice = createSlice({
  name: 'desiredDeliveryAddress',
  initialState,
  reducers: {
    setDesiredDeliveryAddress(state, action: PayloadAction<string | null>) {
      const { payload } = action;

      return payload == null ? initialState : payload;
    },
  },
});

export const { setDesiredDeliveryAddress } = slice.actions;

export default slice.reducer;
